var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.attributes.length > 0 && _vm.variations.length > 0
        ? _vm._l(_vm.attributes, function(attribute) {
            return _c(
              "div",
              { key: attribute.key, staticClass: "product__variation" },
              [
                _c(
                  "label",
                  {
                    staticClass: "product__variation__label",
                    attrs: { for: "variation-" + attribute.key }
                  },
                  [_vm._v(_vm._s(attribute.name))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "product__variation__field select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selections[attribute.key],
                          expression: "selections[attribute.key]"
                        }
                      ],
                      attrs: {
                        id: "variation-" + attribute.key,
                        name: attribute.key
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.selections,
                              attribute.key,
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.updateSelectedVariation()
                          }
                        ]
                      }
                    },
                    _vm._l(attribute.options, function(option) {
                      return _c(
                        "option",
                        {
                          key: option,
                          attrs: {
                            disabled: _vm.isAttributeDisabled(attribute, option)
                          },
                          domProps: { value: option }
                        },
                        [
                          _vm._v(
                            "\n            " + _vm._s(option) + "\n            "
                          ),
                          _vm.isAttributeDisabled(attribute, option)
                            ? [
                                _vm._v(
                                  "\n              (" +
                                    _vm._s(
                                      _vm.$modeoL10n
                                        .not_available_with_selected_options
                                    ) +
                                    ")\n            "
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.getPriceDifference(
                            _vm.selections,
                            attribute.key,
                            option
                          ).with_tax !== 0 && !_vm.hidePrices
                            ? [
                                _vm._v("\n              ("),
                                _c("price", {
                                  attrs: {
                                    "price-without-tax": _vm.getPriceDifference(
                                      _vm.selections,
                                      attribute.key,
                                      option
                                    ).without_tax,
                                    "price-with-tax": _vm.getPriceDifference(
                                      _vm.selections,
                                      attribute.key,
                                      option
                                    ).with_tax,
                                    prefix:
                                      _vm.getPriceDifference(
                                        _vm.selections,
                                        attribute.key,
                                        option
                                      ).with_tax > 0
                                        ? "+"
                                        : ""
                                  }
                                }),
                                _vm._v(")\n            ")
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    }),
                    0
                  )
                ])
              ]
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-74fd73f6", { render: render, staticRenderFns: staticRenderFns })
  }
}